import { fmt, hoje } from "../constants";

export default function TabelaContas({
  aba, abrirNovo, STATUS, lista, filtroStatus, setFiltroStatus,
  loading, filtrada, totalPendente, totalVencido,
  setModalPagar, setDataPag, setForm, setModalForm, excluir,
}) {
  return (
    <>
      <div className="page-toolbar">
        <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> {aba==="pagar"?"Nova Conta a Pagar":"Nova Conta a Receber"}</button>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {Object.entries(STATUS).map(([k,{l}])=>(
            <button key={k} className={"btn btn-secondary"+(filtroStatus===k?" aba-ativa":"")}
              style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setFiltroStatus(filtroStatus===k?"":k)}>
              {l} ({lista.filter(c=>c.status===k).length})
            </button>
          ))}
        </div>
      </div>
      <div className="card">
        <div className="table-wrapper">
          {loading?<div className="table-empty">Carregando...</div>:
          !filtrada.length?<div className="table-empty">Nenhum lancamento encontrado.</div>:
          <table>
            <thead><tr>
              <th>Descricao</th><th>Categoria</th>
              <th>{aba==="pagar"?"Fornecedor":"Cliente"}</th>
              <th>Vencimento</th><th className="td-r">Valor</th>
              <th>Status</th><th></th>
            </tr></thead>
            <tbody>
              {filtrada.map(c=>(
                <tr key={c.id}>
                  <td><strong>{c.descricao}</strong></td>
                  <td className="fs-12 text-secondary">{c.categoria}</td>
                  <td className="fs-13">{c.fornecedor_nome||c.cliente_nome||"—"}</td>
                  <td style={{fontSize:13,color:c.status==="VENCIDO"?"var(--z-danger-text)":"var(--z-text-secondary)"}}>
                    {new Date(c.data_vencimento+"T12:00:00").toLocaleDateString("pt-BR")}
                  </td>
                  <td style={{textAlign:"right",fontWeight:600}}>R$ {fmt(c.valor)}</td>
                  <td><span style={{color:STATUS[c.status]?.cor,fontWeight:600,fontSize:12}}>{STATUS[c.status]?.l}</span></td>
                  <td style={{textAlign:"right",display:"flex",gap:4}}>
                    {(c.status==="PENDENTE"||c.status==="VENCIDO")&&(
                      <button className="btn btn-primary" style={{fontSize:11,padding:"2px 8px"}}
                        onClick={()=>{setModalPagar(c);setDataPag(hoje);}}>
                        {aba==="pagar"?"Pagar":"Receber"}
                      </button>
                    )}
                    <button className="btn btn-secondary" style={{fontSize:11,padding:"2px 8px"}}
                      onClick={()=>{setForm({...c,fornecedor:c.fornecedor?String(c.fornecedor):"",cliente:c.cliente?String(c.cliente):""});setModalForm("editar");}}>
                      Editar
                    </button>
                    <button className="btn btn-danger" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>excluir(c.id)}>Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{borderTop:"2px solid var(--z-border)"}}>
                <td colSpan={4} style={{padding:"8px",textAlign:"right",fontWeight:700}}>
                  Pendente: <span className="text-warning">R$ {fmt(totalPendente)}</span>
                  {totalVencido>0&&<span style={{marginLeft:16,color:"var(--z-danger-text)"}}>Vencido: R$ {fmt(totalVencido)}</span>}
                </td>
                <td colSpan={3}></td>
              </tr>
            </tfoot>
          </table>}
        </div>
      </div>
    </>
  );
}
